import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import CommonAvailabilityWrapper from '../common-availability-wrapper';
import {
  IdealerInfo,
  IuserStoreLocationData
} from '../product-reusable-card/product.type';
import { Conditional } from '@cat-ecom/pcc-components';

export const AvailabilitySection: React.FC<{
  part: MergedPriceAndAvailabilityResponse;
  catcorp: boolean;
  replacementParts: unknown[];
  enableAddToCart: boolean;
  locale: string;
  userStoreLocationData: IuserStoreLocationData;
  dealerInformation: IdealerInfo;
  availRemoveInterimStockFlag: boolean;
  isShowSourcingDetailEnabled: boolean;
  isDeliveryEnabled: boolean;
}> = ({
  part,
  catcorp,
  replacementParts,
  enableAddToCart,
  locale,
  userStoreLocationData,
  dealerInformation,
  availRemoveInterimStockFlag,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled
}) => {
  return (
    <div className="mb-1 d-flex flex-column">
      <Conditional
        test={!catcorp && replacementParts?.length === 0 && enableAddToCart}
      >
        <CommonAvailabilityWrapper
          availabilityData={part}
          shouldDisplayLabel={false}
          isLoading={false}
          locale={locale}
          dealerData={userStoreLocationData}
          dealerInformation={dealerInformation}
          availRemoveInterimStockFlag={availRemoveInterimStockFlag}
          isShowSourcingDetailEnabled={isShowSourcingDetailEnabled}
          isDeliveryEnabled={isDeliveryEnabled}
        />
      </Conditional>
    </div>
  );
};
